import {
  RESET_ADMIN_USER_PASSWORD,
  RESET_ADMIN_USER_PASSWORD_SUCCESS,
  RESET_ADMIN_USER_PASSWORD_ERROR,
  FORGOT_ADMIN_USER_PASSWORD,
  FORGOT_ADMIN_USER_PASSWORD_SUCCESS,
  FORGOT_ADMIN_USER_PASSWORD_ERROR,
  UPDATE_ADMIN_USER_PASSWORD,
  UPDATE_ADMIN_USER_PASSWORD_SUCCESS,
  UPDATE_ADMIN_USER_PASSWORD_ERROR,
} from "./actionTypes"

const initialState_forgotPassword = {
  forgotSuccessMsg: null,
  forgotError: null,
  loading: false,
}

const forgotAdminPassword = (state = initialState_forgotPassword, action) => {
  switch (action.type) {
    case FORGOT_ADMIN_USER_PASSWORD:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
        loading: true,
      }
      break
    case FORGOT_ADMIN_USER_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetSuccessMsg: action.payload,
        loading: false,
      }
      break
    case FORGOT_ADMIN_USER_PASSWORD_ERROR:
      state = { ...state, forgetError: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

const initialState_resetPassword = {
  resetPasswordSuccessMsg: null,
  resetPasswordError: null,
  loading: false,
}
const resetAdminPassword = (state = initialState_resetPassword, action) => {
  switch (action.type) {
    case RESET_ADMIN_USER_PASSWORD:
      state = {
        ...state,
        resetPasswordSuccessMsg: null,
        resetPasswordError: null,
        loading: true,
      }
      break
    case RESET_ADMIN_USER_PASSWORD_SUCCESS:
      state = {
        ...state,
        resetPasswordSuccessMsg: action.payload,
        loading: false,
      }
      break
    case RESET_ADMIN_USER_PASSWORD_ERROR:
      state = { ...state, resetPasswordError: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

const initialState_updatePassword = {
  updatePasswordSuccessMsg: null,
  updatePasswordError: null,
  loading: false,
}
const updateAdminPassword = (state = initialState_updatePassword, action) => {
  switch (action.type) {
    case UPDATE_ADMIN_USER_PASSWORD:
      state = {
        ...state,
        initialState_updatePassword: null,
        updatePasswordError: null,
        loading: true,
      }
      break
    case UPDATE_ADMIN_USER_PASSWORD_SUCCESS:
      state = {
        ...state,
        updatePasswordSuccessMsg: action.payload,
        loading: false,
      }
      break
    case UPDATE_ADMIN_USER_PASSWORD_ERROR:
      state = { ...state, updatePasswordError: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}
export { forgotAdminPassword, resetAdminPassword, updateAdminPassword }
